
import React from "react";
import { useFormContext } from "react-hook-form";
import { FormField, FormItem, FormLabel, FormControl, FormMessage } from "@/components/ui/form";
import { Input } from "@/components/ui/input";
import { AdvancedFieldsConfig } from "./CampaignTypeConfig";
import { Info } from "lucide-react";

interface AdvancedCampaignFieldsProps {
  config: AdvancedFieldsConfig;
}

export const AdvancedCampaignFields: React.FC<AdvancedCampaignFieldsProps> = ({ config }) => {
  const form = useFormContext();

  return (
    <div className="space-y-4">
      <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
        {config.showMaxCoupons && (
          <FormField
            control={form.control}
            name="max_coupons_per_customer"
            render={({ field }) => (
              <FormItem>
                <FormLabel className="text-sm font-medium">
                  Máximo de Cashback por Cliente <span className="text-red-500">*</span>
                </FormLabel>
                <FormControl>
                  <Input 
                    type="number" 
                    placeholder="1" 
                    className="h-10"
                    {...field}
                    onChange={(e) => field.onChange(e.target.value ? Number(e.target.value) : 1)}
                  />
                </FormControl>
                <FormMessage />
              </FormItem>
            )}
          />
        )}

        {config.showDelayDays && (
          <FormField
            control={form.control}
            name="delay_days"
            render={({ field }) => (
              <FormItem className="md:col-span-2">
                <FormLabel className="text-sm font-medium">
                  Delay para Geração do Cashback <span className="text-red-500">*</span>
                </FormLabel>
                <FormControl>
                  <div className="relative">
                    <Input 
                      type="number" 
                      placeholder="3" 
                      className="pr-12 h-10"
                      {...field}
                      onChange={(e) => field.onChange(e.target.value ? Number(e.target.value) : 3)}
                    />
                    <span className="absolute right-3 top-1/2 -translate-y-1/2 text-sm text-gray-500">dias</span>
                  </div>
                </FormControl>
                <FormMessage />
              </FormItem>
            )}
          />
        )}
      </div>

      {config.showDelayDays && (
        <div className="flex items-start gap-3 p-4 bg-blue-50 border border-blue-200 rounded-lg">
          <Info className="h-5 w-5 text-blue-600 mt-0.5 flex-shrink-0" />
          <div className="text-sm text-blue-800">
            <p className="font-medium mb-1">Como funciona o delay:</p>
            <p>
              Após o cliente realizar a compra, o sistema aguarda {form.watch("delay_days") || 3} dias 
              antes de gerar o cashback. Isso garante que o pedido seja processado e pago.
            </p>
          </div>
        </div>
      )}
    </div>
  );
};
